<template>
  <v-container class="p-order-reduce-warp px-0">
    <!-- <v-layout mb-2>
      <v-icon color="#dd122a">chevron_left</v-icon>
      <label class="back">返回保单详情</label>
    </v-layout> -->
    <v-layout column style="background-color:#fff;">
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>减员</v-toolbar-title>
      </v-toolbar>
      <v-layout column class="p-order-reduce">
        <v-layout class="mt-4">
          <v-flex>
            <strong>
              员工总数：
              <em class="em">{{items.length}}</em> 人
            </strong>
            <span>（本人 {{ oneselfCount }} 人，配偶 {{ spouseCount }} 人，子女 {{ childrenCount }} 人）</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-form ref="form" lazy-validation>
              <v-data-table :headers="headers" :items="items" hide-actions class="employee-table">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>
                      <v-checkbox v-model="props.item.checked"></v-checkbox>
                    </td>
                    <td>{{props.item.name}}</td>
                    <td v-if="props.item.relation === 1">本人</td>
                    <td v-else-if="props.item.relation === 10">配偶</td>
                    <td v-else-if="props.item.relation === 40">子女</td>
                    <td>{{props.item.identifyNumber}}</td>
                    <td>{{props.item.mobile}}</td>
                    <td>{{props.item.effectDate}}</td>
                    <td>{{props.item.price}}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout class="mt-4">
          <v-flex>
            <strong class="mr-4" style="color:#F8952A;font-size:14px;">
              勾选的被保险人减员后保障将终止
            </strong>
          </v-flex>
          <v-flex class="d-flex jusify-end">
            <v-btn large>取消</v-btn>
            <v-btn color="primary" large @click="visible=true" :disabled="checkedItems.length === 0" :loading="loading">减员</v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-layout>
    <Reduce v-model="visible" :checkedDate="checkedItems"  @fatherMethod="fatherMethod"></Reduce>
  </v-container>
</template>
<script>
import Reduce from "./components/tkReduce";
export default {
  components:{
    Reduce
  },
  data() {
    return {
      headers: [
        {
          text: "",
          value: "",
          sortable: false
        },
        {
          text: "姓名",
          value: "name",
          sortable: false
        },
        {
          text: "与员工关系",
          value: "relation",
          sortable: false
        },
        {
          text: "证件号码",
          value: "idCard",
          sortable: false
        },
        {
          text: "手机号",
          value: "phone",
          sortable: false
        },
        {
          text: "生效日期",
          value: "startDate",
          sortable: false
        },
        {
          text: "保费",
          value: "price",
          sortable: false
        }
      ],
      allItems: [],
      visible:false,
      userId:null,
      loading: false,
      startDate:''
    };
  },
  computed: {
    items() {
      return this.allItems.filter(item => !item.isDelete)
    },
    checkedItems(){
      return this.items.filter(item => item.checked);
    },
    user() {
      return this.$store.state.user.userInfo;
    },
    businessId() {
      return this.user && this.user.userId;
    },
    oneselfCount() {
      return this.items.filter(item => item.relation === 1).length;
    },
    spouseCount() {
      return this.items.filter(item => item.relation === 10).length;
    },
    childrenCount() {
      return this.items.filter(item => item.relation === 40).length;
    },
    insuredList(){
      let arr = [];
      this.checkedItems.map(item => {
        arr.push({
            insuredName:item.name,
            identifyNumber:item.identifyNumber,
            identifyType:item.identifyType,
            validDate:this.$miment(this.startDate).format("YYYY-MM-DD")
        });
      });
      return arr;
    }
  },
  created(){
    this.$store.dispatch("getUserInfo", true).then(user => {
      if (user) {
        this.userId = user.userId;
        this.getData();
      }
    });  
  },
  methods: {
    getData() {
      const json = {
        userId: this.businessId || this.userId,
        orderCode: this.$route.params.policyCode
      };
      this.$axios
        .post('/app/api/tk/queryDetail', json)
        .then(res => {
          this.allItems = res.data.insureds;
          this.startDate = res.data.policy.insureStartDate
        })
        .catch(err => {
          this.$message.error("保单员工信息异常：" + err);
        });
    },
    fatherMethod(){
      this.loading = true;
      const json = Object.assign({},{
        userId:	this.businessId || this.userId,
        policyNo:this.$route.query.policyNo,
        insuredList:this.insuredList
      })
      this.$axios.post('/app/api/tk/reductionOfInsurant',json).then(res => {
        console.log(res);
        this.loading = false;
        this.$message.success(res);
        this.$router.push({ name: "result",params: { url: 'reduce' }});
      }).catch(err => {
        console.log(err)
        this.loading = false;
        this.$message.error(err.message);
      })
    }
  }
};
</script>
<style lang="scss">
.p-order-reduce-warp {
  .back {
    color: #dd122a;
    font-size: 14px;
    font-weight: bold;
  }
  .p-order-reduce {
    padding: 0 40px 50px;
  }
  table.v-table tbody td:first-child{
    padding-top:16px;
  }
  table.v-table tbody td:not(:nth-child(1)) {
    padding:0 16px;
  }
}
.v-em {
  .employee-table {
    .v-table__overflow {
      max-height: 700px;
      overflow: auto;
    }
  }
}
</style>